import {Injectable} from '@angular/core';
import {LocalStorageService} from '../../core/services/local-storage.service';
import {UndoService} from '../../commands/undo.service';
import {isActivity, isText, isSticker} from '../../diagram-render/helpers/shapes-detectors.util';
import {ActivityCommands} from '../../commands/activity/activity.commands';
import {FlowlineCommands} from '../../commands/flowline/flowline.commands';
import {TextCommands} from '../../commands/text/text.commands';
import {GeneralCommands} from '../../commands/general/general.commands';
import {StickerCommands} from '../../commands/sticky-note/sticker.commands';

@Injectable()
export class StyleClipboardService {
  constructor(
    private activityCommand: ActivityCommands,
    private flowlineCommand: FlowlineCommands,
    private textCommand: TextCommands,
    private generalCommand: GeneralCommands,
    private stickerCommand: StickerCommands,
    private undoSvc: UndoService
  ) {}

  commands = {
    activity: this.activityCommand,
    flowline: this.flowlineCommand,
    text: this.textCommand,
    sticker: this.stickerCommand,
    multi: this.generalCommand
  };

  private cutLineStyles(style) {
    const {line} = style;

    delete style.line;

    return line;
  }

  copy(type, style) {
    const current = this._getCurrent();

    current[type] = style;
    LocalStorageService.set('copiedStyles', JSON.stringify(current));
  }

  paste(cell): void {
    const type = this._getType(cell);

    if (!type) {
      return;
    }

    const style = this._getCurrent()[type];

    if (!style) {
      return;
    }

    const commands = [this.commands[type].changeStyle(cell.id, style, true)];

    if (type === 'flowline') {
      commands.push(this.commands[type].changeForm(cell.getJson(), this.cutLineStyles(style)));
    }

    this.undoSvc.executeCommand(this.generalCommand.group(commands));
  }

  multiPaste(cells): void {
    const commands = [];

    cells.map(cell => {
      const type = this._getType(cell);

      if (!type) {
        return;
      }

      const style = this._getCurrent()[type];

      if (style) {
        if (type === 'flowline') {
          commands.push(this.commands[type].changeForm(cell.getJson(), this.cutLineStyles(style)));
        }

        commands.push(this.commands[type].changeStyle(cell.id, style, true));
      }
    });

    const groupCommand = this.generalCommand.group(commands);

    this.undoSvc.executeCommand(groupCommand);
  }

  checkCanPaste(cell) {
    if (!cell) {
      return;
    }

    const type = this._getType(cell);

    if (!type) {
      return;
    }

    const style = this._getCurrent()[type];

    if (!style) {
      return;
    }

    return true;
  }

  public _getCurrent() {
    const result = LocalStorageService.get('copiedStyles');

    return result || {};
  }

  public _getType(cell) {
    if (!cell) {
      return;
    }

    let type;

    if (isActivity(cell)) {
      type = 'activity';
    }

    if (isText(cell)) {
      type = 'text';
    }

    if (isSticker(cell)) {
      type = 'sticker';
    }

    if (cell.edge) {
      type = 'flowline';
    }

    return type;
  }
}
